/**
 * Extension of Time (Section 259(2)) — M32015
 * DCR + Notice. 필드 키는 Word 템플릿 [[변수]] 와 일치.
 */
export type ExtensionOfTimeFieldType = 'text' | 'date' | 'entity' | 'person' | 'address' | 'clause';

export const EXTENSION_OF_TIME_KEYS = [
  'company_name',
  'company_registration_no',
  'constitution_clause_number',
  'financial_year_end',
  'extension_reason',
  'dcr_date',
  'registered_office_address',
  'company_phone',
  'company_fax',
  'company_email',
  'circulation_deadline',
  'proposed_circulation_extension',
  'proposed_lodgement_extension',
  'agm_deadline',
  'declaration_date',
] as const;

export type ExtensionOfTimeFieldKey = (typeof EXTENSION_OF_TIME_KEYS)[number];

const LABELS: Record<string, string> = {
  company_name: 'Company Name',
  company_registration_no: 'Registration No.',
  constitution_clause_number: 'Clause / Article No.',
  financial_year_end: 'Financial Year End',
  extension_reason: 'Extension Reason',
  dcr_date: 'Resolution Date',
  registered_office_address: 'Registered Office Address',
  company_phone: 'Tel No.',
  company_fax: 'Fax No.',
  company_email: 'E-mail',
  circulation_deadline: 'Circulation Deadline',
  proposed_circulation_extension: 'Proposed Circulation Extension',
  proposed_lodgement_extension: 'Proposed Lodgement Extension',
  agm_deadline: 'AGM Deadline',
  declaration_date: 'Declaration Date',
};

export function labelize(key: string): string {
  return LABELS[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function typeOf(key: string): ExtensionOfTimeFieldType {
  if (key === 'constitution_clause_number') return 'clause';
  if (key === 'financial_year_end' || key === 'circulation_deadline' || key === 'agm_deadline'
    || key === 'dcr_date' || key === 'declaration_date'
    || /_date$|_deadline$|_end$/.test(key)) return 'date';
  if (/_address$/.test(key)) return 'address';
  if (key === 'company_name') return 'entity';
  return 'text';
}

export function isOptional(key: string): boolean {
  return [
    'constitution_clause_number',
    'company_phone',
    'company_fax',
    'company_email',
    'agm_deadline',
    'proposed_circulation_extension',
  ].includes(key);
}

/** required progress keys */
export const EXTENSION_OF_TIME_REQUIRED = EXTENSION_OF_TIME_KEYS.filter((k) => !isOptional(k));
